import React, { useCallback, useEffect } from 'react';
import { downloadSettingExcel } from "src/utils/blob/blobUtil";
import { MST3020_R01Filter, useMST3020_R01Store } from 'src/containers/mes/MST/MST3020_R01/Store_MST3020_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';
import { deleteMST3020_R01, downloadExcel_MST3020_R01, getMST3020_R01AllCount, getMST3020_R01DetailList, getMST3020_R01List, getPdfBlob_MST3020_R01, patchMST3020_R01 } from "./Api_MST3020_R01";
import { defaultMST3020_R01DetailDto, defaultMST3020_R01HeaderDto, MST3020_R01DetailDto, MST3020_R01Dto, MST3020_R01HeaderDto } from './Dto_MST3020_R01';
import { AgGridReact } from 'ag-grid-react';
import { gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { validateWareHouseCd, validateWorkPlaceCd } from 'src/utils/grid/GridValidateContent';
import { useQzPrint } from 'src/hooks/useQzPrint';
import qz from 'qz-tray';

interface Props {
	gridRef: React.RefObject<AgGridReact<MST3020_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<MST3020_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_MST3020_R01 = (props: Props) => {

	const {
		gridRef, 
		setMessage,
	} = props;

	const { compCdList, warehouseCdList, workPlaceList } = useCommonCodeStore();

	
	const {
		MST3020_R01Filter, 
		setMST3020_R01PastFilter,
		MST3020_R01List, setMST3020_R01List,
		editMST3020_R01, setEditMST3020_R01,
		selectedMST3020_R01, setSelectedMST3020_R01, 
		deletedMST3020_R01DetailList, setDeletedMST3020_R01DetailList, addDeletedMST3020_R01DetailList, removeDeletedMST3020_R01DetailList, 
		selectedMST3020_R01DetailList, setSelectedMST3020_R01DetailList,  removeSelectedMST3020_R01DetailList,
		MST3020_R01DetailList, setMST3020_R01DetailList, insertMST3020_R01DetailList,
		 setEditMST3020_R01Detail,
		 setOriginalMST3020_R01DetailList,
		 setAllCount,
		initData,
		detailFetchTrigger, setDetailFetchTrigger,
		setScrollTop,
		setDetailScrollTop,
	} = useMST3020_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { printPdfFromBlob } = useQzPrint();

	useFetchActionbarAuth("MST3020_R01");

	const handlePrintClick = useCallback(async () => {
		if (!selectedMST3020_R01 || !selectedMST3020_R01.itemCd) {
				showWarning("출력할 품목정보를 선택하세요.");
				setMessage("출력할 품목정보를 선택하세요.");
				return;
			}
			setLoadingSpinner(true);
			try {
				const blob = await getPdfBlob_MST3020_R01(selectedMST3020_R01.itemCd);
				if (qz.websocket.isActive()) {
					const ok = await printPdfFromBlob(blob, "report1");
					if (ok) {
						showSuccess("PDF 출력을 완료하였습니다.");
					} else {
						const fileURL = URL.createObjectURL(blob);
						window.open(fileURL, "_blank");
						setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
					}
				} else {
					const fileURL = URL.createObjectURL(blob);
					window.open(fileURL, "_blank");
					setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
					showSuccess("PDF를 새 탭에서 열었습니다.");
				}
			} catch (error) {
				setMessage("PDF 출력 중 오류가 발생했습니다.");
			} finally {
				setLoadingSpinner(false);
			}
	}, [selectedMST3020_R01, printPdfFromBlob, setLoadingSpinner, setMessage]);
	

	const handleExcelClick = useCallback(async () => {
		if (!selectedMST3020_R01) {
			showWarning("선택된 품목정보가 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_MST3020_R01('', selectedMST3020_R01.itemCd, MST3020_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '작업표준 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedMST3020_R01])

	const getParams = (filter: MST3020_R01Filter) => {
		const params: Partial<MST3020_R01Filter> = {
			brandCd: filter.brandCd || undefined,
			itemGroup: filter.itemGroup || undefined,
			itemAccount: filter.itemAccount || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getMST3020_R01AllCount(getParams(MST3020_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [MST3020_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setLoadingSpinner(true);
		setScrollTop(null);
		setDetailScrollTop(null);
	
		const responseData = (await getMST3020_R01List(
			'search',
			getParams(MST3020_R01Filter),
			MST3020_R01List.length ?? 0
		));


		let newList = [...responseData.data.data ] as MST3020_R01HeaderDto[];
		setMST3020_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedMST3020_R01,
				() => true,// () => !responseData.find(value => value.salBillNo === selectedMST3020_R01?.salBillNo)
			);
			setMST3020_R01PastFilter(MST3020_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		}else {
			showWarning('데이터가 없습니다.');
			setSelectedMST3020_R01(undefined);
			setMST3020_R01List([]);
			setMST3020_R01DetailList([]); 
			setDeletedMST3020_R01DetailList([]);
			setSelectedMST3020_R01DetailList([]);
			setOriginalMST3020_R01DetailList([]);
			handleCreateClick();
		}
		setLoadingSpinner(false);
		return responseData;
	}, [MST3020_R01Filter, MST3020_R01List, setMST3020_R01List, setMST3020_R01PastFilter, setSelectedMST3020_R01, selectedMST3020_R01, setScrollTop, setDetailScrollTop])

	const defaultMST3020_R01DetailRow = useCallback(() => {
		return {
			...defaultMST3020_R01DetailDto,
			inserted: true,
		}
	}, [defaultMST3020_R01DetailDto]);

	const fetchDetailList = useCallback(async (itemCd: string) => {
		const responseData = (await getMST3020_R01DetailList(itemCd)).data.data;
		if(responseData && responseData.length > 0){
			const detailList = responseData.map((value: MST3020_R01DetailDto, idx: number) => ({
				...value,
				valueIndex: value.valueIndex ?? idx + 1,
				orderIndex: value.orderIndex ?? idx + 1,
				orderIndexSeq: value.orderIndexSeq ?? 0,
			}));

			setMST3020_R01DetailList(detailList);
			setEditMST3020_R01Detail(detailList[0]);
			setOriginalMST3020_R01DetailList(responseData);
			setMessage(`${selectedMST3020_R01?.itemNm}의 작업표준 ${responseData.length}건을 조회하였습니다.`);
			setTimeout(() => setMessage(""), 5000);
		}else{
			setEditMST3020_R01Detail(defaultMST3020_R01DetailDto);
			setMST3020_R01DetailList([]);
			insertMST3020_R01DetailList([{ ...defaultMST3020_R01DetailRow() }]);
		}
	}, [selectedMST3020_R01, defaultMST3020_R01DetailRow, insertMST3020_R01DetailList, setEditMST3020_R01Detail, setMST3020_R01DetailList, setOriginalMST3020_R01DetailList, setMessage]);
	
	const initContainerData = useCallback(() => {
		initData();
		removeDeletedMST3020_R01DetailList();
		removeSelectedMST3020_R01DetailList();
		setEditMST3020_R01({
			...defaultMST3020_R01HeaderDto,
		})
	}, [compCdList, selectedMST3020_R01])

	const handleDeleteClick = useCallback(() => {

		if (deletedMST3020_R01DetailList.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구
			removeDeletedMST3020_R01DetailList(deletedMST3020_R01DetailList);
			removeSelectedMST3020_R01DetailList();
			setMST3020_R01DetailList([...MST3020_R01DetailList]);
		} else if (selectedMST3020_R01DetailList.length > 0) {
			addDeletedMST3020_R01DetailList(selectedMST3020_R01DetailList);
			removeSelectedMST3020_R01DetailList(selectedMST3020_R01DetailList);
		}
	}, [selectedMST3020_R01DetailList, 
		deletedMST3020_R01DetailList,
		addDeletedMST3020_R01DetailList,
		removeDeletedMST3020_R01DetailList,
		removeSelectedMST3020_R01DetailList,
		setMST3020_R01DetailList,
		MST3020_R01DetailList]);
	
	const handleCreateClick = () => {
		setSelectedMST3020_R01(undefined);
		setEditMST3020_R01({
			...defaultMST3020_R01HeaderDto
		})
		setMST3020_R01DetailList([{ ...defaultMST3020_R01DetailRow() }]);
		setDeletedMST3020_R01DetailList([]);
		setSelectedMST3020_R01DetailList([]);
		setOriginalMST3020_R01DetailList([]);
	}

	const validateInsertData = (header: MST3020_R01HeaderDto, detailList: MST3020_R01DetailDto[]) => {

		const deletedDetailListToString = deletedMST3020_R01DetailList.map(value => value.toString());
		const activeDetailList = detailList.filter(detail => !deletedDetailListToString.includes(detail.valueIndex.toString()));

		// 1. 필수 값 유효성 검사
		for (const detail of activeDetailList) {
			if (!detail.workplaceCd) {
				showWarning('공정코드를 입력해주세요.'); 
				return false;
			}
			if (!validateWorkPlaceCd(detail.workplaceCd, workPlaceList)) {
				showWarning('공정코드가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
			}
			if (!detail.warehouseCd) {
				showWarning('입고창고를 입력해주세요.'); 
				return false;
			}
			if (!validateWareHouseCd(detail.warehouseCd, warehouseCdList)) {
				showWarning('입고창고가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
			}
		}

		// 2. 공정코드 중복 검사
		const workplaceCds = activeDetailList.map(detail => detail.workplaceCd).filter(Boolean);
		const duplicates = workplaceCds.filter((workplaceCd, index) => workplaceCds.indexOf(workplaceCd) !== index);

		if (duplicates.length > 0) {
			// 중복된 코드에 해당하는 이름을 찾아 경고 메시지에 사용
			const firstDuplicateCode = duplicates[0];
			const duplicateItem = activeDetailList.find(detail => detail.workplaceCd === firstDuplicateCode);
			const duplicateName = duplicateItem ? duplicateItem.workplaceNm : firstDuplicateCode;

			showWarning(`중복된 공정코드가 있습니다. : ${duplicateName}`);
			return false;
		}

		return true;
	}

	const setInfoDetailList = useCallback((header: MST3020_R01HeaderDto, detailList: MST3020_R01DetailDto[]) => {
		
		return detailList.map((value, idx) => ({
			...value,
			itemCd: header.itemCd,
		}))
	}, [setMST3020_R01DetailList])
	
	const handleSaveClick = useCallback(async () => {

		let valid = true;
		if(!validateInsertData(editMST3020_R01!, MST3020_R01DetailList)) valid = false;
		if(!valid) { return; }
		
		const deletedMST3020_R01DetailList_Number = deletedMST3020_R01DetailList.map(value => Number(value));
		let processName = '';
		let newDetailList: MST3020_R01DetailDto[] = [];
		let newHeaderList: MST3020_R01HeaderDto[] = [];
		let responseData: MST3020_R01Dto = {
			itemHeaderDto: selectedMST3020_R01!,
			tqcWorkStandardDetailDtoList: MST3020_R01DetailList
		};

		try {
			
			if (selectedMST3020_R01) {
				newDetailList = MST3020_R01DetailList.filter(value => 
					!deletedMST3020_R01DetailList_Number.includes(value.valueIndex)
				);

				if (newDetailList.length === 0) {
					processName = 'delete';
					const deleteResponse = await deleteMST3020_R01(selectedMST3020_R01.itemCd);

					newHeaderList = MST3020_R01List.filter(value => value.itemCd !== selectedMST3020_R01.itemCd);

					if (deleteResponse && deleteResponse.data) {
						if (deleteResponse.data.successFlag) {
							showSuccess('작업표준정보 삭제가 성공하였습니다.');
							setMessage('작업표준정보 삭제가 성공하였습니다.');
						}else return;
					}
				} else {
					processName = 'patch';

						const patchResponse = await patchMST3020_R01({
							itemHeaderDto: selectedMST3020_R01!,
							tqcWorkStandardDetailDtoList: setInfoDetailList(selectedMST3020_R01!, newDetailList)
						});

						if (patchResponse?.data?.data?.[0] && patchResponse.data.successFlag) {
							responseData = patchResponse.data.data[0];
							newHeaderList = MST3020_R01List.map(value => {
								if (value.itemCd === responseData.itemHeaderDto.itemCd) {
									return responseData.itemHeaderDto;
								}
								return value;
							});
							
							showSuccess('작업표준정보 수정에 성공하였습니다.');
							setMessage('작업표준정보 수정에 성공하였습니다.');
						}
				}
			}
			
		} catch (error: any) {
			console.log('error :', error.response?.data?.message || error.message);
			showError(error.response?.data?.message || '작업표준정보 작업 중 오류가 발생했습니다.');
			return;
		}


		if (processName === 'delete') {
			setMST3020_R01List(newHeaderList);
			setSelectedMST3020_R01(undefined);
			setMST3020_R01DetailList([]);
			handleCreateClick();
		}else if (processName === 'patch' || processName === 'post') {
			setMST3020_R01List(newHeaderList);
			setMST3020_R01DetailList(responseData.tqcWorkStandardDetailDtoList);
			setSelectedMST3020_R01(responseData.itemHeaderDto);
			setOriginalMST3020_R01DetailList(responseData.tqcWorkStandardDetailDtoList);
		}

		// setSelectedMST3020_R01(undefined);
		setDeletedMST3020_R01DetailList([]);
		setSelectedMST3020_R01DetailList([]); // 저장 후 상세행 선택 상태 초기화
		setTimeout(() => {
			setMessage('');
		}, 5000)
	
	}, [
		MST3020_R01List, setMST3020_R01List,
		selectedMST3020_R01, 
		editMST3020_R01, 
		MST3020_R01DetailList, 
		deletedMST3020_R01DetailList, 
	])

	// 상세 조회
	useEffect(() => {
		if (!detailFetchTrigger || !selectedMST3020_R01?.itemCd) return;
		fetchDetailList(selectedMST3020_R01.itemCd);
		setDetailFetchTrigger(false);
	}, [detailFetchTrigger, selectedMST3020_R01, fetchDetailList, setDetailFetchTrigger]);

	useEffect(() => {
		if (selectedMST3020_R01 && MST3020_R01DetailList.length === 0) {
			insertMST3020_R01DetailList([{ ...defaultMST3020_R01DetailRow() }])
		}
	}, [selectedMST3020_R01, MST3020_R01DetailList])
	
	return {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		defaultMST3020_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	};
}
